import Vue from 'vue'
import firebase from '@/firebase'
import {parseDocumentsToObject} from '@/utils/populations'


export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
    items: {}
  },
  actions: {
    async initialize ({commit}) {
      console.log('seriales initialize')
      commit('LOADING', true)
      firebase.firestore.collection('seriales').onSnapshot(
        (result) => commit('ON_SNAPSHOT', parseDocumentsToObject(result.docs)),
        (err) => commit('ERROR', err)
      )
    }
  },
  mutations: {
    LOADING (state, loading) {
      Vue.set(state, 'loading', loading)
    },
    ON_SNAPSHOT (state, items = {}) {
      Vue.set(state, 'items', items)
      Vue.set(state, 'loading', false)
    },
    ERROR (state, error) {
      console.error(error)
      Vue.set(state, 'error', error)
      Vue.set(state, 'loading', false)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/seriales.js